// extracted by mini-css-extract-plugin
module.exports = {"root":"HTTPError-module__root--1fVdd","text":"HTTPError-module__text--3j84F"};